export default __webpack_public_path__ + "static/media/save.958aff8d.svg";